<div class="height100p flex-col">
    @if (!embeddedComponent) {
        <sm-toolbar class="flex-item-fixed">
            <p-button severity="success" icon="fas fa-save" label="Speichern" (onClick)="save()">
            </p-button>
            @if (!isInsert() && definition.canInsert) {
                <p-button severity="info" icon="fas fa-save" label="Als Kopie speichern" (onClick)="saveNew()">
                </p-button>
             }
             <p-button severity="secondary" icon="fas fa-times" label="Abbrechen" (onClick)="close()">
            </p-button>
            @if (isInsert()) {
                <p-checkbox appLabel="Mehrfach-Anlegen-Modus" [binary]=true [(ngModel)]="multiInsert"></p-checkbox>
            }
        </sm-toolbar>
    }
    <div class="flex-item-fill overflow-y-auto">
        <div class="form-container">
            <p-card>
                <sm-form [form]="form">
                </sm-form>
            </p-card>
        </div>
    </div>
</div>